import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { switchMap, tap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private estaReautenticando = false;
  constructor(private authenticationService: AuthenticationService) {}

  private adicionarToken(request: HttpRequest<unknown>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const naoAutenticar = ['/Login', '/Login/refreshToken', '/Senha'];

    if (naoAutenticar.includes(request.url)) {
      return next.handle(request);
    }

    const token = this.authenticationService.obterRawToken();
    const { id, exp, refreshToken } = this.authenticationService.obterToken();

    const dataComDoisMinutosAMais = Math.floor((Date.now() + 120000) / 1000);
    if (!this.estaReautenticando && dataComDoisMinutosAMais >= exp) {
      this.estaReautenticando = true;
      return this.authenticationService
        .reautenticarUsuario({
          idUsuario: id,
          token,
          refreshToken
        })
        .pipe(
          tap({
            error: () => {
              this.authenticationService.logoutUsuario();
            }
          }),
          switchMap(({ data: { token } }) => {
            this.estaReautenticando = false;
            return next.handle(this.adicionarToken(request, token));
          })
        );
    }

    return next.handle(this.adicionarToken(request, token));
  }
}
